module.exports = __webpack_public_path__ + "static/Cloud-Footer-896b7432593824da95e3e8df9fe5ad78.png";